import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function BlogBanner() {

  const [BlogBanner, setBlogBanner] = useState({});

  useEffect(() => {
    const fetchBlogBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/blogs/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setBlogBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBlogBanner();
  }, []);

  return (
  
      <div className='common-banner-sec common-flex-center blog-banner'
      style={{
        backgroundImage: `url(${
          apiUrl.apiUrl + `/` + BlogBanner.banner_image
        })`,
      }}
      >
        <div className='overlay'></div>
        <Container fluid>
          <Row className='common-flex-center'>
            <Col md={8}>
                <div className=' '>
                    <h1 className='common-head whiteColor'>{BlogBanner.banner_title}</h1>
                    <p className='common-para whiteColor'>{BlogBanner.banner_description}</p>
                </div>
            </Col>
          </Row>
        </Container>
      </div>
 
  );
}

export default BlogBanner;